import { Controller } from "@hotwired/stimulus"
import { gsap } from "gsap"

import { isTouchDevice } from "../helpers"
export default class extends Controller {
  static targets = [ "searchPanel", "searchForm", "searchInput" ]

  initialize() {
    this.setupTl()
    this.activeClass = 'search-active'
  }

  setupTl(){
    this.tl = gsap.timeline({
      paused: true,
      onComplete:()=>{
          this.searchInputTarget.focus()
        // console.log(isTouchDevice)
        //   this.searchInputTarget.focus()
        // if(!isTouchDevice){
        // }
      }
    })
    .fromTo(this.searchPanelTarget,.25,{
      autoAlpha:0
    },{
      autoAlpha:1,
      ease:"power4.out"
    })
  }

  show(){
    this.tl.play()
    document.querySelector('body').classList.add(this.activeClass)
  }

  hide(){
    document.querySelector('body').classList.remove(this.activeClass)
    this.tl.reverse()
  }

  submit(){

  }


  disconnect(){
    // this.hide()
  }
}